import React, { useState } from "react";

import {
  TextField,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  auditButtonCenter: {
    display: "flex",
    justifyContent: "center",
    margin: theme.spacing(2),
  },
}));

const AuditSummary = ({ currentAudit, finishAudit, isCompleted }) => {
  let [audit, setAudit] = useState(currentAudit);
  let matchCount = 0;
  let noMatchCount = 0;
  let itemsNotFound = 0;
  const classes = useStyles();

  const handleComplete = () => {
    debugger;
    const completed = isCompleted();
    completed && finishAudit(audit);
  };

  currentAudit.processedItems &&
    currentAudit.processedItems.forEach((itm) => {
      if (itm.quantityPhysical === 0) itemsNotFound++;
      else if (itm.quantityPhysical !== itm.quantityOnHand) noMatchCount++;
      else if (itm.quantityPhysical === itm.quantityOnHand) matchCount++;
    });

  return (
    <Card>
      <CardHeader title="Audit summary" subheader="" />
      <CardContent>
        <Grid container spacing="2">
          <Grid item sm={12}>
            <Typography component="p">
              Total items processed: {currentAudit.processedItems.length}
            </Typography>
          </Grid>
          <Grid item sm={12}>
            <Typography component="p">Items matched: {matchCount}</Typography>
          </Grid>
          <Grid item sm={12}>
            <Typography component="p">
              Items not matched: {noMatchCount}
            </Typography>
          </Grid>
          <Grid item sm={12}>
            <Typography component="p">
              Missing items: {itemsNotFound}
            </Typography>
          </Grid>
          <Grid item sm={12}>
            <TextField
              name="note"
              id="audit-note"
              label="Notes"
              multiline
              minRows={4}
              value={audit.notes ? audit.notes : " "}
              margin="dense"
              variant="outlined"
              fullWidth
              onChange={(evt) =>
                setAudit({ ...audit, notes: evt.target.value })
              }
            />
          </Grid>
        </Grid>
      </CardContent>
      <div className={classes.auditButtonCenter}>
        <Button
          size="large"
          onClick={handleComplete}
          variant="contained"
          color="secondary"
        >
          Complete Audit
        </Button>
      </div>
    </Card>
  );
};

export default AuditSummary;
